import * as actionTypes from "Redux/Actions/actionTypes";

const doVerificationCodeAction = (userdata, callback = () => {}) => ({
  type: actionTypes.VERIFICATIONCODE_REQUEST,
  data: userdata,
  callback,
});

export default doVerificationCodeAction;
